import WatchedData from '../../../model/watcher/WatchedData';

export default class WatchedContentData extends WatchedData {
  _redraw = false;
  _frameRange = null;

  constructor(frameRange, forcedRedraw = false) {
    super();

    this._redraw = forcedRedraw;
    this._frameRange = frameRange;
  }

  getKey() {
    return `${this.frameRange.toString()}-${this.redraw}`;
  }

  get frameRange() {
    return this._frameRange;
  }

  set frameRange(value) {
    this._frameRange = value;
  }

  get redraw() {
    return this._redraw;
  }

  set redraw(redraw) {
    this._redraw = redraw;
  }
}
